import { Stack, Text, Title } from "@mantine/core"

type StepperStepHeaderProps = Readonly<{
  eyebrow: string
  title: string
  subtitle?: string
}>

export const StepperStepHeader = ({
  eyebrow,
  title,
  subtitle,
}: StepperStepHeaderProps) => {
  return (
    <Stack component="header" gap={0} style={{ flexShrink: 0 }}>
      <Text
        component="div"
        size="xs"
        fw={700}
        tt="uppercase"
        c="var(--tfg-text-color-secondary)"
      >
        {eyebrow}
      </Text>
      <Title order={2} my={"xs"}>
        {title}
      </Title>
      {subtitle ? (
        <Text size="sm" c="var(--tfg-text-color-secondary)" maw={540} m={0}>
          {subtitle}
        </Text>
      ) : null}
    </Stack>
  )
}
